import React from 'react';
import { Link } from 'react-router-dom';
import { get } from 'lodash';
import TableRow from '../../../../ReusableComponents/Table/TableRow';
import TableCell from '../../../../ReusableComponents/Table/TableCell';
import {
  formatTime,
  formatDate,
} from '../../../../../Lib/Utils/Date/format-booking-timestamp';
import { Booking } from '../../../../../Lib/Hooks/types/booking';

interface Props {
  booking: Booking;
}

function BookingRow({ booking }: Props) {
  const userId = get(booking, 'vendor.contacts[0].id');

  return (
    <TableRow>
      <TableCell>{formatTime(booking)}</TableCell>
      <TableCell>{formatDate(booking)}</TableCell>
      <TableCell>{booking.location.name}</TableCell>
      <TableCell>{booking.vendor.legal_name}</TableCell>
      <TableCell>
        {booking.purchase_orders.map((po) => (
          <Link
            key={po.po_number}
            to={`users/${userId}/purchase-orders/${po.po_number}`}
          >
            <div>{po.po_number}</div>
          </Link>
        ))}
      </TableCell>
    </TableRow>
  );
}

export default BookingRow;
